import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

export default function PreviewSection({ rrule }) {
  const { t } = useTranslation('common');

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          {t('common:rrule.preview.title')}
        </Typography>

        <Box
          sx={{
            p: 2,
            bgcolor: 'grey.50',
            borderRadius: 1,
            minHeight: 40,
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontFamily: 'monospace' }}
          >
            {rrule || t('common:rrule.preview.empty')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
